import Swiper from "swiper/bundle";

const iconTextSlider = document.querySelector(".assets-image-slider");

if (iconTextSlider) {

  const swiper = new Swiper(iconTextSlider, {
    direction: "horizontal",
    loop: true,
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 24,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
   
      1200: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
}